import type { Locale } from "../../content/types"
import { getPagePath } from "../../content/registry"
import { ui } from "../../content/ui"

export interface NavLinkItem {
  label: string
  path: string
}

/** Top-level navigation, resolved through the page registry. */
export function getNavLinks(locale: Locale): NavLinkItem[] {
  return [
    { label: ui.nav.home[locale], path: getPagePath("home", locale)! },
    { label: ui.nav.services[locale], path: getPagePath("services", locale)! },
    { label: ui.nav.cases[locale], path: getPagePath("cases", locale)! },
    { label: ui.nav.insights[locale], path: getPagePath("insights", locale)! },
    { label: ui.nav.about[locale], path: getPagePath("about", locale)! },
    { label: ui.nav.contact[locale], path: getPagePath("contact", locale)! },
  ]
}

export function isActiveNav(currentPathname: string, linkPath: string): boolean {
  if (linkPath === "/nl/" || linkPath === "/en/") return currentPathname === linkPath
  return currentPathname === linkPath || currentPathname.startsWith(linkPath)
}
